<template>
  <div class="member-edit-page" v-loading='loading'>
    <div class="page-title">{{title}}</div>
    <ul class='checkbox-area'>
      <li v-for='item in data' :key="item.name">
        <template v-if='!item.isCheck'>
          <div class='type1'>
            <span class='name'>{{item.name}}</span>
            <span class='line'></span>
            <Checkbox  v-for='subItem in item.child' :key='subItem.type_2' v-model="subItem.is_enable">{{subItem.type_2}}</Checkbox>
          </div>
        </template>
        <template v-else>
          <div class='type2'>
            <div class='left'><span class='name'>{{item.name}}</span><span class='line'></span></div>
            <div class='right'>
               <div v-for='(subItem, subIndex) in item.child' :key='subItem.type_2' class='subChild'>
                <Checkbox v-model='subItem.is_enable' :disabled='subItem.isCheck'>{{subItem.type_2}}</Checkbox>
                  <RadioGroup v-model="subItem.single">
                    <Radio label="limit">
                        <input type="text" v-model='subItem.num' class='num' @input='checkInput(subIndex)' :disabled='subItem.single === "noLimit"' :class="{'dis': subItem.single === 'noLimit'}">
                        <span class='text'>条</span>
                    </Radio>
                    <Radio label="noLimit">
                        <span class='text'>不限</span>
                    </Radio>
                </RadioGroup>
                <template v-if='subItem.isCheck'>
                  <DatePicker v-model="subItem.start_date" :clearable="false" :editable="false" type="date" placeholder="开始日期" style="width: 120px"></DatePicker>
                  <span class='line2'></span>
                  <DatePicker v-model="subItem.end_date" :clearable="false" :editable="false" type="date" placeholder="结束日期" style="width: 120px"></DatePicker>
                </template>
              </div>
            </div>
          </div>
        </template>
      </li>
    </ul>
    <pageBottomLine
      text='提交保存'
      @confirm='handleSubmit'
    ></pageBottomLine>
  </div>
</template>
<script>
import { permissionList, memberPermissionEdit } from '@/api/member'
import { dateObjToStr2 } from '@/utils/common.js'
import pageBottomLine from '@/components/pageCom/pageBottomLine'
import _ from 'underscore'
export default {
  name: 'memberReEdit',
  components: { pageBottomLine },
  data() {
    return {
      data: [],
      title: '',
      loading: false
    }
  },
  mounted() {
    this.initPage()
    this.getData()
    this.$store.commit('SET_RETURN_TYPE', 'wide')
  },
  methods: {
    initPage() {
      this.$store.dispatch('setPage', { title: '编辑', type: '' })
      const arr = ['免费会员', '初级会员', '中级会员', '高级会员']
      this.title = arr[this.$route.params.id]
    },
    getData() {
      this.loading = true
      const tmpArr = []
      permissionList({ level: this.$route.params.id }).then(res => {
        this.loading = false
        if (res.code === 0) {
          res.result.forEach(item => {
            if (item.length) {
              const obj = {}
              obj.name = item[0].type_1
              obj.isCheck = obj.name === '一键检索'
              item.forEach(subItem => {
                if (subItem.is_enable === '0') {
                  subItem.is_enable = false
                } else {
                  subItem.is_enable = true
                }
                if (obj.name === '一键检索') {
                  if (subItem.view_num === '0') {
                    subItem.single = 'noLimit'
                    subItem.num = ''
                  } else {
                    subItem.single = 'limit'
                    subItem.num = subItem.view_num
                  }
                  if (subItem.type_2 === '中标情况' || subItem.type_2 === '年报销售数据') {
                    subItem.isCheck = true
                  }
                }
              })
              obj.child = item
              tmpArr.push(obj)
            }
          })
          this.chuliData(tmpArr)
        } else if (res.code !== 10008) {
          this.$Message.info(res.msg)
          this.data = []
        }
      })
    },
    handleSubmit() {
      const Flag = this.checkParams()
      if (Flag) {
        const data = this.getParams()
        memberPermissionEdit(data).then(res => {
          if (res.code === 0) {
            this.$Message.info('保存成功')
            this.$router.go(-1)
          } else if (res.code !== 10008) {
            this.$Message.info(res.msg)
          }
        })
      }
    },
    checkParams() {
      let Flag = true
      this.data.forEach(sub => {
        if (sub.isCheck) {
          const item = sub.child
          for (var i = 0; i < item.length; i++) {
            if (item[i].is_enable === true) {
              if (item[i].single === 'limit' && !item[i].num) {
                this.$Message.info('主数据' + item[i].type_2 + '条数不能为空')
                Flag = false
                return false
              }
              if (item[i].isCheck) {
                if (item[i].start_date && item[i].end_date) {
                  if (item[i].start_date > item[i].end_date) {
                    this.$Message.info('时间格式不正确')
                    Flag = false
                    return false
                  }
                }
              }
            }
          }
        }
      })
      return Flag
    },
    getParams() {
      const totalParams = {}
      totalParams.level = this.$route.params.id
      const paramsArr = []
      this.data.forEach(item => {
        item.child.forEach(subItem => {
          const obj = {}
          obj.level = this.$route.params.id
          obj.is_enable = subItem.is_enable ? '1' : '0'
          obj.type_1 = subItem.type_1
          obj.type_2 = subItem.type_2
          if (item.name === '一键检索') {
            obj.view_num = subItem.single === 'limit' ? subItem.num : '0'
          } else {
            obj.view_num = item.view_num
          }
          if (subItem.type_2 === '中标情况' || subItem.type_2 === '年报销售数据') {
            obj.start_date = subItem.start_date ? dateObjToStr2(subItem.start_date) + ' 00:00:00' : subItem.start_date
            obj.end_date = subItem.end_date ? dateObjToStr2(subItem.end_date) + ' 23:59:59' : subItem.end_date
          } else {
            obj.start_date = subItem.start_date
            obj.end_date = subItem.end_date
          }
          paramsArr.push(obj)
        })
      })
      totalParams.permission = paramsArr
      return totalParams
    },
    checkInput: _.debounce(function(subIndex) {
      const reg = /^[1-9]\d*$/
      this.data.forEach(item => {
        if (item.isCheck) {
          if (item.child[subIndex].num !== '') {
            if (!reg.test(item.child[subIndex].num)) {
              item.child[subIndex].num = ''
            }
          }
        }
      })
    }, 500, false),
    chuliData(tmpArr) {
      const stand1 = ['工作台', '账户', '首页', '市场', '准入', '任务', '销售', '分析监控', '智能建表', '数据清洗', '原始数据', '主数据库', '一键检索', '报告中心', '直播工具']
      const stand2 = [
        '中国基药数据库',
        '国产药品数据库',
        '进口药品数据库',
        '中国医保数据库',
        '生产企业数据库',
        '医生数据库',
        '中国医院数据库',
        '中国商业数据库',
        '中国药店数据库',
        '中国医疗机构库'
      ]
      stand1.forEach(item => {
        for (var i = 0; i < tmpArr.length; i++) {
          if (item === tmpArr[i].name) {
            if (item === '一键检索') {
              const tmp2 = []
              stand2.forEach(subItem => {
                for (var j = 0; j < tmpArr[i].child.length; j++) {
                  if (subItem === tmpArr[i].child[j].type_2) {
                    tmp2.push(tmpArr[i].child[j])
                    return false
                  }
                }
              })
              tmpArr[i].child = tmp2
            }
            this.data.push(tmpArr[i])
          }
        }
      })
    }
  }
}
</script>
<style lang="scss">
  .member-edit-page {
    overflow: hidden;
    padding: 0 20px 0 30px;
    .page-title {
      margin-top: 10px;
      color: #5D6F80;
      font-size: 16px;
      height: 16px;
      line-height: 16px;
      // font-family: PingFangSC-Semibold;
      font-weight: 600;
    }
    ul {
      li {
        min-height: 50px;
        .type1 {
          line-height: 50px;
        }
        .type2 {
          .left {
            height: 50px;
            line-height:48px;
          }
          .right {
            margin-top: -42px;
            margin-left: 110px;
            .subChild {
              height: 50px;
              .ivu-checkbox-wrapper {
                vertical-align: middle;
              }
              .ivu-radio-wrapper {
                vertical-align: middle;
                margin-left: 17px;
                &:nth-child(2) {
                  margin-left: 30px;
                }
              }
              .num {
                height: 30px;
                width: 50px;
                padding-left: 10px;
                vertical-align: middle;
              }
              .dis {
                opacity: 0.3;
              }
              .text {
                margin-left: 6px;
                vertical-align: middle;
                &:nth-child(2) {
                  margin-left: 2px;
                  margin-right: 30px;
                }
              }
              .ivu-date-picker {
                vertical-align: middle;
              }
            }
          }
        }
      }
    }
    .name {
      display: inline-block;
      text-align: right;
      width: 50px;
      color: #5D6F80;
      // font-family: PingFangSC-Regular;
      font-weight:400;
    }
    .line {
      border-right: 1px solid rgba(0, 0, 0, 1);
      margin: 0 30px;
      opacity: 0.1;
    }
    .ivu-checkbox-wrapper {
      min-width: 120px;
    }
    .line2 {
      border-top: 1px solid rgba(225,228,241,1);
      display: inline-block;
      width: 18px;
      vertical-align: middle;
      margin: 0 4px;
    }
  }
</style>
